var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJavaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.6 45.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8971d;}.cls-2{fill:#58839f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "java-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.08,189.45c2.21,2.54-.58,4.83-.58,4.83s5.61-2.9,3-6.52c-2.4-3.38-4.25-5.06,5.74-10.86,0,0-15.68,3.92-8.19,12.55",
    transform: "translate(-179.05 -167.55)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.53,167.55s4.76,4.76-4.51,12.08c-7.44,5.87-1.7,9.22,0,13-4.34-3.92-7.52-7.36-5.39-10.58,3.14-4.71,11.83-7,9.91-14.55",
    transform: "translate(-179.05 -167.55)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.06,206.11q0,4.82-3.25,7.24L219.25,212a6.41,6.41,0,0,0,1.39-2.9,16.59,16.59,0,0,0,.24-3.19V188.23h3.19Z",
    transform: "translate(-179.05 -167.55)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M238.4,208.18H236l-.24-1.6a6.89,6.89,0,0,1-4.55,1.89q-4.43,0-4.43-4.08a4.23,4.23,0,0,1,1.8-3.64,9.77,9.77,0,0,1,5.7-1.39h1.07V198q0-2.63-3-2.63a12.6,12.6,0,0,0-4.32.86l-.44-1.86a13.71,13.71,0,0,1,5.59-1.21q5.23,0,5.23,4.46Zm-3-3.4v-3.49h-1.27q-4.28,0-4.29,2.66a2,2,0,0,0,2.28,2.31,5.14,5.14,0,0,0,3.28-1.48",
    transform: "translate(-179.05 -167.55)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.18,193.46a58,58,0,0,1-4.55,14.72h-3.75l-4.52-14.72h3.28l2.81,9,.62,2.72A55.13,55.13,0,0,0,250,193.46Z",
    transform: "translate(-179.05 -167.55)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.65,208.18h-2.36l-.24-1.6a6.91,6.91,0,0,1-4.55,1.89q-4.43,0-4.43-4.08a4.23,4.23,0,0,1,1.8-3.64,9.78,9.78,0,0,1,5.71-1.39h1.06V198q0-2.63-3-2.63a12.6,12.6,0,0,0-4.31.86l-.44-1.86a13.72,13.72,0,0,1,5.59-1.21q5.23,0,5.23,4.46Zm-3-3.4v-3.49h-1.27q-4.29,0-4.29,2.66a2,2,0,0,0,2.28,2.31,5.13,5.13,0,0,0,3.28-1.48",
    transform: "translate(-179.05 -167.55)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.93,203s-1.75,1,1.25,1.36a26.24,26.24,0,0,0,9.49-.4,16.38,16.38,0,0,0,2.52,1.23c-9,3.85-20.3-.22-13.25-2.19",
    transform: "translate(-179.05 -167.55)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.84,198s-2,1.45,1,1.76a37.09,37.09,0,0,0,12.24-.59,5.42,5.42,0,0,0,1.89,1.15c-10.84,3.17-22.92.25-15.16-2.32",
    transform: "translate(-179.05 -167.55)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.94,206.68s1.3,1.07-1.43,1.89c-5.18,1.57-21.54,2-26.09.06-1.64-.71,1.43-1.7,2.39-1.9a6.42,6.42,0,0,1,1.58-.18c-1.82-1.28-11.75,2.52-5,3.6,18.28,3,33.33-1.33,28.59-3.47",
    transform: "translate(-179.05 -167.55)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M190.77,192.76s-8.33,2-2.95,2.7a62.78,62.78,0,0,0,11-.12c3.45-.29,6.9-.91,6.9-.91a14.58,14.58,0,0,0-2.09,1.12c-8.45,2.23-24.79,1.19-20.08-1.08a15.75,15.75,0,0,1,7.21-1.7",
    transform: "translate(-179.05 -167.55)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.71,201.11c8.59-4.46,4.62-8.76,1.85-8.18a6.61,6.61,0,0,0-1,.26,1.57,1.57,0,0,1,.74-.57c5.49-1.93,9.7,5.69-1.77,8.71a.77.77,0,0,0,.17-.23",
    transform: "translate(-179.05 -167.55)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.62,213.21c8.25.53,20.92-.29,21.22-4.2,0,0-.58,1.48-6.82,2.66a67.8,67.8,0,0,1-20.88.32s1.05.87,6.48,1.22",
    transform: "translate(-179.05 -167.55)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavaLogo);
export default __webpack_public_path__ + "static/media/java-logo.52e848adb03b9dab7e9b131085fea32a.svg";
export { ForwardRef as ReactComponent };